import { POPUP_ALERT_TYPES } from "src/components/Kit/PopupAlert/popup-alert-types";


export const colorDictionary: Record<POPUP_ALERT_TYPES, string> = {
    DANGER: '#F25325',
    INFO: '#FDA92C'
}